import * as Mui from "@mui/material";

const ArticleSelect = ({ data, articleId, handleOnChange }) => {
  return (
    <>
      {data.isLoading && <Mui.Skeleton height={40} />}
      {!data.isLoading && (
        <>
          <Mui.InputLabel id="articles">Ürün Makalesi</Mui.InputLabel>
          {!data.isError && (
            <Mui.Select
              sx={{ background: "#fff" }}
              fullWidth
              defaultValue=""
              key={articleId}
              size="small"
              labelId="articles"
              id="articles"
              value={articleId}
              label="Ürün Makalesi"
              onChange={handleOnChange}
            >
              <Mui.MenuItem value={0}>Makale Seçiniz</Mui.MenuItem>
              {data.data?.length > 0 &&
                data.data.map((row, i) => (
                  <Mui.MenuItem key={i} value={row.id}>
                    {row.title}
                  </Mui.MenuItem>
                ))}
            </Mui.Select>
          )}
          {data.isError && (
            <Mui.Select
              defaultValue={articleId}
              key={articleId}
              size="small"
              labelId="articles"
              id="articles"
              value={articleId}
              label="Ürün Makalesi"
            >
              <Mui.MenuItem value={0}>Makale Bulunamadı</Mui.MenuItem>
            </Mui.Select>
          )}
        </>
      )}
    </>
  );
};

export default ArticleSelect;
